<script>
    import WebFontLoader from 'webfontloader';
    import color from 'color';
    import jss from 'jss';
    //import preset from 'jss-preset-default'

    export default {
        name: 'StylesUpdater',
        render() {
            return null;
        },
        data() {
            return {
                customStyles: {
                    title: 'Relm',
                    subtitle: 'It\'s time to evolve',
                    imageLogo: '',
                    favicon: '',
                    fontContent: 'Nunito Sans',
                    fontTitle: 'Oswald',
                    colorBodyBackground: '#DBD6D2',
                    colorContentBackground: '#FFFFFF',
                    colorContentPrimary: '#42545E',
                    colorContentTonic: '#3F8ED3',
                    colorContentOver: '#F22B15',
                    colorTopbarBackground: '#FFFFFF',
                    colorFooterBackground: '#E5E5E5'
                }
            };
        },
        watch: {
            '$store.state.websiteSettings': function () {
                if (this.$store.state.websiteSettings !== null) {
                    this.customStyles = this.$store.state.websiteSettings.styles;
                    this.updateStyle();
                }
            }
        },
        methods: {
            computedCustomStyles() {
                // Gradient Color update
                this.customStyles.colorBodyGradientStart = this.customStyles.colorBodyBackground;
                this.customStyles.colorBodyGradientEnd = color(this.customStyles.colorBodyBackground).darken(0.3).hex();
            },
            updateStyle() {
                this.computedCustomStyles();
                WebFontLoader.load({
                    google: {
                        families: [this.customStyles.fontContent, this.customStyles.fontTitle]//['Nunito Sans', 'Courgette']
                    }
                });
                const createGenerateClassName = () => {
                    return (rule) => `custom-${rule.key}`;
                };
                jss.setup({ createGenerateClassName });

                const styles = {
                    // Default
                    'html': {
                        'font-family': this.customStyles.fontContent
                    },
                    'body': {
                        'color': this.customStyles.colorContentPrimary,
                        'background-color': this.customStyles.colorBodyBackground,
                        'background-image': 'linear-gradient(' + this.customStyles.colorBodyGradientStart + ', ' + this.customStyles.colorBodyGradientEnd + ')'
                    },
                    // Spinner
                    'LoadingSpinner-spinner_loading': {
                        'border': '10px solid ' + this.customStyles.colorContentTonic,
                        'border-bottom-color': 'transparent'
                    },
                    // Main
                    'Wrapper-main': {
                        'background-color': this.customStyles.colorBodyBackground,
                        'background-image': 'linear-gradient(' + this.customStyles.colorBodyGradientStart + ', ' + this.customStyles.colorBodyGradientEnd + ')'
                    },
                    'h1': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'h2': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'h3': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'h4': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'h5': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'h6': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'p': {
                        'font-family': this.customStyles.fontContent,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'li': {
                        'font-family': this.customStyles.fontContent,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'a': {
                        'font-family': this.customStyles.fontContent,
                        'color': this.customStyles.colorContentTonic + ' !important'
                    },
                    'a_hover': {
                        'color': this.customStyles.colorContentOver + ' !important'
                    },
                    // Header
                    'WebsiteHeader': {
                        'background-color': this.customStyles.colorTopbarBackground,
                        'color': this.customStyles.colorContentPrimary,
                        'border-bottom': '1px solid ' + color(this.customStyles.colorTopbarBackground).darken(0.15).hex()
                    },
                    'WebsiteHeader-baseline': {
                        'font-family': this.customStyles.fontTitle
                    },

                    // Footer
                    'WebsiteFooter': {
                        'background-color': this.customStyles.colorFooterBackground,
                        'color': this.customStyles.colorContentPrimary,
                        'border-top': '1px solid ' + color(this.customStyles.colorFooterBackground).darken(0.05).hex()
                    },
                    'WebsiteFooter-copyright': {
                        'text-shadow': '0 1px 2px ' + color(this.customStyles.colorFooterBackground).darken(0.2).hex()
                    },

                    // Share Content
                    'ShareBar-icon': {
                        'background-color': this.customStyles.colorTopbarBackground,
                        'fill': this.customStyles.colorContentPrimary,
                        'text-shadow': '0 0 10px ' + color(this.customStyles.colorTopbarBackground).fade(0.25) + ', 0 1px 1px ' + color(this.customStyles.colorContentPrimary).fade(0.25),
                        'box-shadow': '0 0 10px ' + color(this.customStyles.colorTopbarBackground).fade(0.25) + ', 0 1px 1px ' + color(this.customStyles.colorContentPrimary).fade(0.25)
                    },
                    'ShareBar-icon_hover': {
                        'background-color': this.customStyles.colorContentOver,
                        'color': this.customStyles.colorTopbarBackground,
                        'fill': this.customStyles.colorTopbarBackground,
                        'border-color': this.customStyles.colorContentOver
                    },

                    // Article Preview
                    'ArticlePreview-header': {
                        'border-left': '6px solid ' + this.customStyles.colorContentTonic,
                        'color': this.customStyles.colorContentPrimary,
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticleHeader': {
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticleFooter': {
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticlePreview-header_hover': {
                        'border-left-color': this.customStyles.colorContentOver
                    },
                    'ArticleHeader-readmore': {
                        'color': this.customStyles.colorContentPrimary
                    },
                    'ArticleHeader-readmore_hover': {
                        'color': this.customStyles.colorContentOver + ' !important',
                        'border': 'none'
                    },
                    'ArticlePreview-header_title': {
                        'font-family': this.customStyles.fontTitle
                    },
                    'ArticlePreview-header_subtitle': {
                        'font-family': this.customStyles.fontTitle
                    },
                    'ArticlePreview': {
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticlePreview-main': {
                        'font-family': this.customStyles.fontContent,
                        'color': this.customStyles.colorContentPrimary,
                        'background-color': this.customStyles.colorContentBackground
                    },

                    // Readmore button
                    'ArticleFooter-readmore': {
                        'background-color': this.customStyles.colorContentBackground,
                        'border-color': color(this.customStyles.colorContentPrimary).fade(0.5).hex()
                    },
                    'ArticleFooter-readmore_text': {
                        'color': this.customStyles.colorContentPrimary,
                        'font-family': this.customStyles.fontTitle
                    },

                    'ArticleFooter-readmore_hover': {
                        'background-color': this.customStyles.colorContentOver + ' !important',
                        'border-color': this.customStyles.colorContentOver + ' !important',
                        'color': this.customStyles.colorContentBackground + ' !important'
                    },
                    'ArticleFooter-readmore_text_hover': {
                        'color': this.customStyles.colorContentBackground + ' !important'
                    },

                    // Full article
                    'ArticlePage-main': {
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticleContent-header': {
                        'border-left': '6px solid ' + this.customStyles.colorContentTonic,
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticleContent-main': {
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticleHeader-title': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary + ' !important'
                    },
                    'ArticleHeader-subtitle': {
                        'font-family': this.customStyles.fontTitle,
                        'color': this.customStyles.colorContentPrimary + ' !important'
                    },
                    // Navigation
                    'ArticleNavigationSide': {
                        'background-color': color(this.customStyles.colorBodyGradientEnd).fade(0.5)
                    },
                    'ArticleNavigationArticle': {
                        'background-color': this.customStyles.colorContentBackground
                    },
                    'ArticleNavigation-header': {
                        'border-left-color': this.customStyles.colorContentTonic,
                        'background-color': this.customStyles.colorContentBackground,
                        'color': this.customStyles.colorContentPrimary
                    },
                    'ArticleNavigation-title': {
                        'color': this.customStyles.colorContentPrimary,
                        'font-family': this.customStyles.fontContent
                    },
                    'ArticleNavigation-subtitle': {
                        'color': this.customStyles.colorContentPrimary,
                        'font-family': this.customStyles.fontContent
                    },

                    'ArticleNavigationLink': {
                        'background-color': this.customStyles.colorContentBackground,
                        'border-color': color(this.customStyles.colorContentPrimary).fade(0.5).hex()
                    },
                    'ArticleNavigationLink-title': {
                        'color': this.customStyles.colorContentPrimary + ' !important',
                        'font-family': this.customStyles.fontTitle
                    },

                    'ArticleNavigationLink_hover': {
                        'background-color': this.customStyles.colorContentOver + ' !important',
                        'border-color': this.customStyles.colorContentOver + ' !important',
                        'color': this.customStyles.colorContentBackground + ' !important'
                    },
                    'ArticleNavigationLink-title_hover': {
                        'background-color': this.customStyles.colorContentOver + ' !important',
                        'color': this.customStyles.colorContentBackground + ' !important'
                    },
                    'ArticleNavigationLink-icon': {
                        'fill': this.customStyles.colorContentPrimary + ' !important'
                    },
                    'ArticleNavigationLink-icon_hover': {
                        'fill': this.customStyles.colorContentBackground + ' !important'
                    }
                };
                //document.getElementsByClassName('ShareBar-icon')[0].setAttribute("fill", "red")

                // Compile styles, apply plugins.
                const sheet = jss.createStyleSheet(styles);

                // If you want to render on the client, insert it into DOM.
                sheet.attach();

                // If you want to render server-side, get the css text.
                sheet.toString();

                //document.getElementsByClassName('WebsiteHeader-logo-link')[0].removeAttribute('style')

            }
        }
    };
</script>
